import {FC} from 'react'
import ManagementDashboard from './ManagementDashboard'

const DashboardWrapper: FC = () => {
  return (
    <>
      <h1 className='fs-3 fw-bolder mb-5'>Dashboard</h1>
      <ManagementDashboard />
    </>
  )
}

export {DashboardWrapper}
export default DashboardWrapper
